import { apiConfig } from '../api-config';

export interface CreatePaymentParams {
  name: string;
  numInscricao: string;
  address: string;
  number: string;
  cep: string;
  city: string;
  neighboor: string;
  uf: string;
  telephone: string;
  initialInstallmentToProcess: number;
  quantityOfInstallmentsToProcess: number;
  totalInstallment: number;
  totalPenaltyDue: number;
  cdTerritory: string;
}

export const createPaymentAxiosInstance = (params: CreatePaymentParams) => {
  return apiConfig.post('/api/Payment/create', params);
};

export const createPayment = async (params: CreatePaymentParams) => {
  return apiConfig
    .post('/api/Payment/create', params)
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, err }));
};
